<page-header [title]="'Merchant Profile'" [subtitle]="subtitle"></page-header>

<form [formGroup]="merchantForm" *ngIf="!loading">
  <div class="row" style="margin-bottom: 70px">
    <div class="col-lg-6">
      <div class="detail-container" id="left" style="margin-bottom: 20px">
        <div class="form-field-label" style="color: black; font-weight: bold">
          Account Details
        </div>
        <div class="form-field" style="margin-top: 20px">
          <div class="form-field-label">First name</div>
          <input
            class="form-input"
            autocomplete="off"
            [formControl]="firstNameFormControl"
            type="text"
          />
        </div>
        <div class="form-field" style="margin-top: 20px">
          <div class="form-field-label">Last Name</div>
          <input
            class="form-input"
            autocomplete="off"
            [formControl]="lastNameFormControl"
            type="text"
          />
        </div>

        <div class="form-field" style="margin-top: 20px">
          <div class="form-field-label">Email</div>
          <input
            class="form-input"
            autocomplete="off"
            [formControl]="emailFormControl"
            type="email"
          />
        </div>

        <div class="action-container">
          <app-secondary-button
            [title]="'Change Password'"
            [disabled]="loading || saving"
            (tapped)="changePassword()"
          ></app-secondary-button>
          <app-primary-button
            [title]="'Save'"
            [disabled]="loading || saving"
            (tapped)="updateMerchant()"
            bgColor="var(--app-timber)"
            color="white"
          ></app-primary-button>
        </div>
      </div>

      <div class="detail-container" id="left" style="margin-bottom: 20px">
        <div class="form-field-label" style="color: black; font-weight: bold">
          Settings
        </div>
        <div class="form-field" style="margin-top: 20px">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div>
              <div class="form-field-label">NFC Scanner</div>
              <div
                style="
                  color: var(--app-text-grey);
                  font-size: 14px;
                  margin-top: 5px;
                "
              >
                Enable NFC scanning in the customer app for giving stamps and
                redeeming rewards
              </div>
            </div>
            <mat-slide-toggle
              [checked]="hasNFC"
              [disabled]="loading || saving"
              (change)="toggleNFC($event.checked)"
            ></mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="detail-container" id="left">
        <div class="form-field-label" style="color: black; font-weight: bold">
          Business Details
        </div>
        <div class="form-field" style="margin-top: 20px">
          <div class="form-field-label">Business Name</div>
          <input
            class="form-input"
            placeholder="e.g. Coffee Shops LTD"
            autocomplete="off"
            [formControl]="merchantNameFormControl"
            type="text"
          />
        </div>

        <div class="form-field" style="margin-top: 20px">
          <single-select
            label="Business Type"
            [formCtrl]="businessTypeFormControl"
            [options]="businessTypes"
            [value]="businessTypeFormControl.value"
            [showIcon]="false"
          ></single-select>
        </div>

        <div class="form-field-label" style="margin-top: 20px">Logo</div>
        <file-upload
          [enabled]="canManageMerchant"
          [aspectRatio]="1 / 1"
          (fileSelected)="selectedLogo = $event"
          [readerResult]="initialMerchantLogo ?? ''"
        ></file-upload>

        <div
          class="form-field"
          style="margin-top: 20px"
          *ngIf="canManageMerchant"
        >
          <mat-radio-group
            [value]="selectedOption"
            aria-label="Select an option"
            (change)="selectedOption = $event.value"
          >
            <div class="form-field-label" style="text-align: left">
              Location Branding<span
                ><info-icon [text]="tooltip"></info-icon
              ></span>
            </div>
            <div
              *ngFor="let option of options"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-left: 20px;
              "
            >
              <span>{{ option.label }}</span>
              <mat-radio-button [value]="option.value"></mat-radio-button>
            </div>
          </mat-radio-group>
        </div>

        <div class="action-container" *ngIf="canManageMerchant">
          <app-primary-button
            [title]="'Save'"
            [disabled]="loading || saving"
            (tapped)="updateMerchant()"
            bgColor="var(--app-timber)"
            color="white"
          ></app-primary-button>
        </div>
      </div>
    </div>
  </div>
</form>

<loader [loading]="loading"></loader>
<loader [loading]="saving"></loader>
